import {Alert, Button, Card, Col, Form, Input, Row, Select} from 'antd';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Mutation} from "react-apollo";
import {ColumnSelector} from '../../ColumnSelector';
import ManifestPrintoutLayoutSelect from "../../printout/layout-selector";

const getColumnSets  = (report_type) => {
    const paxColumns = [
        {
            setName: 'Columns',
            key: 'columns',
            columns: [
                {
                    label: 'First Name',
                    key: 'firstName'
                },
                {
                    label: 'Last Name',
                    key: 'lastName'
                },
                {
                    label: 'Flight',
                    key: 'currentCarrier.desig'
                },
                {
                    label: 'Departure',
                    key: 'departure.name'
                },
                {
                    label: 'Destination',
                    key: 'destination.name'
                },
                {
                    label: 'Pax Weight',
                    key: 'paxWeight'
                },
                {
                    label: 'Bag Weight',
                    key: 'bagWeight'
                },
                {
                    label: 'Bag Count',
                    key: 'bagCount'
                },
                {
                    label: 'Transporter',
                    key: 'transporter.name'
                },
                {
                    label: 'Customer',
                    key: 'customer.name'
                },
                {
                    label: 'Employer',
                    key: 'employer.name'
                },
                {
                    label: 'Checked-In-Time',
                    key: 'checkedInTime'
                },
                {
                    label: 'Finalization reason',
                    key: 'finalizationReasonType'
                },
                {
                    label: 'Charge Code',
                    key: 'chargeCode'
                },
                {
                    label: 'Tail Num',
                    key: 'currentCarrier.aircraftDoc.tailNum'
                },
                {
                    label: 'Aircraft Model',
                    key: 'currentCarrier.aircraftDoc.model'
                }
                //{
                //    label: 'State',
                //    key: 'nodeState'
                //}
            ]
        }
    ]
    const paxCovidVaxColumns = [
        {
            setName: 'Columns',
            key: 'columns',
            columns: [
                {
                    label: 'First Name',
                    key: 'firstName'
                },
                {
                    label: 'Last Name',
                    key: 'lastName'
                },
                {
                    label: 'Is Vaccinated',
                    key: 'isVaccinated'
                },
                {
                    label: 'Flight',
                    key: 'currentCarrier.desig'
                },
                {
                    label: 'Departure',
                    key: 'departure.name'
                },
                {
                    label: 'Destination',
                    key: 'destination.name'
                },
                {
                    label: 'Pax Weight',
                    key: 'paxWeight'
                },
                {
                    label: 'Bag Weight',
                    key: 'bagWeight'
                },
                {
                    label: 'Bag Count',
                    key: 'bagCount'
                },
                {
                    label: 'Transporter',
                    key: 'transporter.name'
                },
                {
                    label: 'Customer',
                    key: 'customer.name'
                },
                {
                    label: 'Employer',
                    key: 'employer.name'
                },
                {
                    label: 'Checked-In-Time',
                    key: 'checkedInTime'
                },
                {
                    label: 'Finalization reason',
                    key: 'finalizationReasonType'
                },
                {
                    label: 'Charge Code',
                    key: 'chargeCode'
                },
                {
                    label: 'Essential On',
                    key: 'essentialOn'
                }
                //{
                //    label: 'State',
                //    key: 'nodeState'
                //}
            ]
        }
    ]
    const personCovidVaxDetails = [
        {
            setName: 'Columns',
            key: 'columns',
            columns: [
                {
                    label: 'First Name',
                    key: 'firstName'
                },
                {
                    label: 'Last Name',
                    key: 'lastName'
                },
                {
                    label: 'DOB',
                    key: 'dob'
                },
                {
                    label: 'Employer',
                    key: 'employerName'
                },
                {
                    label: 'Shot Manufacturer',
                    key: 'shotManufacturer'
                },
                {
                    label: 'Shot 1',
                    key: 'shot_1'
                },
                {
                    label: 'Shot 2',
                    key: 'shot_2'
                },
                {
                    label: 'Vaccinated on',
                    key: 'vaccinated_on'
                },
                {
                    label: 'POS Test',
                    key: 'pos_test'
                },
                {
                    label: 'RTW',
                    key: 'rtw'
                },
                {
                    label: 'RTW 2',
                    key: 'rtw_2'
                },
                {
                    label: 'Essential On',
                    key: 'essentialOn'
                }
                // {
                //     label: 'Booster 1',
                //     key: 'booster_1'
                // },
                // {
                //     label: 'Booster 2',
                //     key: 'booster_2'
                // }
            ]
        }
    ]
    const covidColumns = [
        {
            setName: 'Columns',
            key: 'columns',
            columns: [
                {
                    label: 'Checked-In-Time',
                    key: 'checkedInTime'
                },
                {
                    label: 'Last Name',
                    key: 'lastName'
                },
                {
                    label: 'First Name',
                    key: 'firstName'
                },
                {
                    label: 'Customer',
                    key: 'customer.name'
                },
                {
                    label: 'Employer',
                    key: 'employer.name'
                },
                {
                    label: 'Departure',
                    key: 'departure.name'
                },
                {
                    label: 'Symptoms',
                    key: 'covid_hasFluSymptoms'
                },
                {
                    label: 'Has High Temp',
                    key: 'covid_selfReportedHighBodyTemperature'
                },
                {
                    label: 'Exposed to Covid',
                    key: 'covid_ExposedToVirus'
                },
                {
                    label: 'Vaccinated',
                    key: 'covid_hasBeenVaccinated'
                }
            ]
        }
    ]
    const cgoColumns = [
        {
            setName: 'Columns',
            key: 'columns',
            columns: [
                {
                    label: 'Name',
                    key: 'name'
                },
                {
                    label: 'Flight',
                    key: 'currentCarrier.desig',
                },
                {
                    label: 'Departure',
                    key: 'departure.name'
                },
                {
                    label: 'Destination',
                    key: 'destination.name'
                },
                {
                    label: 'Ground Pickup',
                    key: 'groundPickup'
                },
                {
                    label: 'Weight',
                    key: 'weight'
                },
                {
                    label: 'Transporter',
                    key: 'transporter.name'
                },
                {
                    label: 'Customer',
                    key: 'customer.name'
                },
                {
                    label: 'Check-In-Time',
                    key: 'checkedInTime'
                },
                {
                    label: 'Initials',
                    key: 'initials'
                },
                {
                    label: 'State',
                    key: 'nodeState'
                },
                {
                    label: 'Charge Code',
                    key: 'chargeCode'
                },
                {
                    label: 'Last Modified',
                    key: 'modifiedTs'
                },
                {
                    label: 'Delivered By',
                    key: 'deliveredBy'
                }
            ]
        }
    ]
    const isnColumns = [
        {
            setName: 'Columns',
            key: 'columns',
            columns: [
                {
                    label: 'Last Name',
                    key: 'lastName'
                },
                {
                    label: 'First Name',
                    key: 'firstName'
                },
                {
                    label: 'Checked-In-Time',
                    key: 'checkedInTime'
                },
                {
                    label: 'Departure',
                    key: 'departure.name'
                },
                {
                    label: 'Destination',
                    key: 'destination.name'
                },
                {
                    label: 'Transporter',
                    key: 'transporter.name'
                },
                {
                    label: 'Customer',
                    key: 'customer.name'
                },
                {
                    label: 'Employers',
                    key: 'employer.name'
                },
                {
                    label: 'ISN Status',
                    key: 'isn_status',
                    format: 'isn_status'
                },
                {
                    label: 'ISN ID',
                    key: 'lastIsnResultWithHeader.selectedResult.isnId'
                },
                {
                    label: 'Training Deficiencies',
                    key: 'trainingDeficiencies',
                    format: 'get_selected_result'
                },
                {
                    label: 'Reasons For Non Compliance',
                    key: 'reasonsForNonCompliance',
                    format: 'get_selected_result'
                },
                {
                    label: 'Overridden By',
                    key: 'overridden_by',
                    format: 'overridden_by'
                },
                {
                    label: 'Override Notes',
                    key: 'authorization.brdRestriction_Isn.notes'
                },
                {
                    label: 'Overrider Reason',
                    key: 'authorization.brdRestriction_Isn.overriderReason'
                },
                {
                    label: 'Assigned Activities',
                    key: 'assignedActivities',
                    format: 'get_selected_result'
                }
            ]
        }
    ]

    const personHotfuel = [
        {
            setName: 'Columns',
            key: 'columns',
            columns: [
                {
                    label: 'Last Name',
                    key: 'lastName'
                },
                {
                    label: 'First Name',
                    key: 'firstName'
                },
                {
                    label: 'Customer',
                    key: 'customerName'
                },
                {
                    label: 'Employer',
                    key: 'employerName'
                },
                {
                    label: 'HotFuel Expiration Date',
                    key: 'hotfuelExpirationDate'
                }
            ]
        }
    ]

    const paxIsnEventsColumns = [
        {
            setName: 'Columns',
            key: 'columns',
            columns: [
                "Event Timestamp",
                "Event Type",
                "Pax Name",
                "Pax ID",
                "Destination",
                "Customer",
                "Employer",
                "Scheduled Flight Date",
                "ISN Status",
                "ISN Reason",
                "ISN Company",
                "ISN ID",
                "Override Type",
                "Override Time",
                "Override Title",
                "Override Reason",
                "Training or Whitelist",
                "Overrider Name",
                "Approver Name",
                "Override Notes",
                "Deleted Ts",
                "Created Ts",
                "Created By",
                "Modified Ts",
                "Modified By",

            ]
            .map(col => ({ label: col, key: col }))
        }
    ]

    const noColumns = []

    switch (report_type) {
        case 'PAX':
            return paxColumns
        case 'CGO':
            return cgoColumns
        case 'MANIFEST':
            return noColumns
        case 'ISN':
            return isnColumns
        case 'COVID':
            return covidColumns
        case 'PAX_COVID19_VAX':
            return paxCovidVaxColumns
        case 'PERSON_COVID19_VAX_DETAILS':
            return personCovidVaxDetails
        case 'PERSON_HOTFUEL':
            return personHotfuel
        case 'PAX_ISN_EVENTS':
            return paxIsnEventsColumns
        default:
            return null
    }
}

export const renderExport = (report_type, report_id) => {
    const column_sets = getColumnSets(report_type);
    if (!column_sets){
        return <div>Unknown report type</div>
    }
    return <ReportExporter report_id={report_id} column_sets={column_sets} report_type={report_type}  />
}

const file_types = [
    {
        key: 'xlsx',
        label: 'Excel',
        content_type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    {
        key: 'csv',
        label: 'CSV',
        content_type: 'text/csv'
    },
    {
        key: 'json',
        label: 'JSON',
        content_type: 'application/json'
    }
]

var ReportExporter = ({
        report_type,
        report_id,
        data,
        export_name,
        column_sets,
        titleRowText,
        criteria,
        default_file_type="csv",
        export_as_zip=false,
        form: { getFieldDecorator, validateFieldsAndScroll, getFieldValue } }) => {
    const [ downloadUrl, setDownloadUrl ] = useState(null);
    const [ desig, setDesig] = useState(null)
    const exportedFileType = downloadUrl && downloadUrl.split('.').slice(-1)[0];
    const single_column_set = column_sets.length === 1;

    let mutation_name = report_id ? 'export_report' : 'export_data';

    let mut = `
    mutation ExportReport(
            ${report_id ? "$report_id: ID!," : "$data: AWSJSON!,"}
            ${!report_id ? "$export_name: String!" : ""}
            ${!report_id ? "$report_type: String!" : ""}
            ${!report_id ? "$criteria: [ReportCriteriaInput!]!" : ""}
            $file_type: String!,
            $content_type: String!,
            $column_sets: [ExportReportColumnSetInput!]!
            $export_as_zip: Boolean
            $titleRowText: String
            $printout_layout: String
        ) {
            ${report_id ? "export_report" : "export_data"}(
                ${report_id ? "report_id: $report_id," : "data: $data,"}
                ${!report_id ? "export_name: $export_name" : ""}
                ${!report_id ? "report_type: $report_type" : ""}
                ${!report_id ? "criteria: $criteria" : ""}
                file_type: $file_type,
                content_type: $content_type,
                column_sets: $column_sets
                export_as_zip: $export_as_zip
                titleRowText: $titleRowText
                printout_layout: $printout_layout
            )
        }
    `

    return (
        <Mutation
            mutation={gql(mut)}
            onCompleted={(data) => setDownloadUrl(data[mutation_name])}
        >
        {(export_report, { loading, error }) => {
            const submit = () => {
                validateFieldsAndScroll((err, values) => {
                    if (!err){
                        const selectedFileType = file_types.find(({ key }) => key === values.file_type);
                        let _criteria;
                        if (Array.isArray(criteria)){
                            _criteria = [ ...criteria ];
                            _criteria = _criteria.map((c) => {
                                if ('__typename' in c){
                                    delete c.__typename;
                                }

                                return {
                                    ...c,
                                    value: JSON.stringify(c.value)
                                }
                            })

                        }

                        let fileType = values.file_type;
                        let contentType = selectedFileType && selectedFileType.content_type;

                        if (report_type === 'MANIFEST'){
                            fileType = 'xlsx';
                            contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                        }

                        export_report({
                            variables: {
                                export_as_zip: export_as_zip,
                                report_id: report_id,
                                criteria: _criteria,
                                data: typeof data === 'string' ? data : JSON.stringify(data),
                                report_type: report_type,
                                export_name: export_name,
                                file_type: fileType,
                                content_type: contentType,
                                titleRowText: values.titleRowText ? values.titleRowText.replace(',', '') : undefined,
                                printout_layout: values.printoutLayout,
                                column_sets: column_sets.map(colSet => {
                                    const newColumns = values[colSet.key] && values[colSet.key]
                                        .filter(col => col.checked)
                                        .map(({ label, key, dataIndex, format }) => ({ label, key: dataIndex ? dataIndex : key, format }));
                                    const newColSet = {
                                        ...colSet,
                                        columns: newColumns
                                    }
                                    return newColSet
                                })
                            }
                        })
                    }
                })
            }
            const renderColumnSelector = (colSet, formItemProps={}) => {
                if (!colSet){
                    return null
                }
                return <Form.Item {...formItemProps}>
                    {getFieldDecorator(colSet.key, {
                        initialValue: colSet.columns.map(col => ({
                            ...col,
                            checked: typeof col.checkedByDefault === 'boolean' ? col.checkedByDefault : true,
                            disabled: col.locked ? true : false
                        })),
                        valuePropName: 'columns'
                    })(<ColumnSelector disabled={loading} />)}
                </Form.Item>
            }

            function renderFileType() {
                switch (report_type) {
                    case "MANIFEST":
                        return null;
                    default:
                        return (
                            <Form.Item label="File Type">
                                {getFieldDecorator('file_type', {
                                    initialValue: default_file_type,
                                    rules: [
                                        {required: true, message: 'You must choose a file type'}
                                    ]
                                })(
                                    <Select style={{ width: '10rem' }} disabled={loading} showAction={["focus", "click"]}>
                                        {file_types.map(({ key, label }) => <Select.Option key={key}>{label}</Select.Option>)}
                                    </Select>
                                )}
                            </Form.Item>
                        )
                }
            }

            function renderTitleRowText() {
                switch (report_type) {
                    case "MANIFEST":
                        return null;
                    default:
                        return <Form.Item label="Title Row Text">
                            {getFieldDecorator('titleRowText', {
                                initialValue: titleRowText
                            })(
                                <Input max={100}/>
                            )}
                        </Form.Item>
                }
            }

            function renderColumnSets(){
                switch (report_type){
                    case "MANIFEST":
                        return null
                    default:
                        return (
                            <Row type="flex" gutter={12} style={{ flexWrap: 'wrap' }}>
                                {column_sets.map((colSet, i) => (
                                    <Col style={{ minWidth: '25rem' }} key={i}>
                                        {single_column_set ? renderColumnSelector(colSet, { label: 'Columns' }) : (
                                            <Card size="small" title={colSet.setName + ':'}>
                                                {renderColumnSelector(colSet)}
                                            </Card>
                                        )}
                                    </Col>
                                ))}
                            </Row>
                        )
                }
            }

            function renderExportButton() {
                return (
                    <Button
                        onClick={submit}
                        loading={loading}
                        type="primary"
                    >Export Report</Button>
                );
            }

            function renderDownloadButton() {
                if (!downloadUrl) return null;
                return (
                    <React.Fragment>
                        <h4>Export finished! Click the button below to download your report.</h4>
                        {exportedFileType === 'json' ? (
                            <Alert
                                type="info"
                                showIcon
                                message="NOTE WHEN DOWNLOADING JSON FILES"
                                description="Your browser will display, but not download your JSON file. To download you will need to right-click, then click Save As..., or press Ctrl + S."
                                style={{ marginBottom: '1rem' }}
                            />
                        ) : null}
                        <a href={downloadUrl} target="_blank" rel="noopener noreferrer">
                            <Button
                                type="primary"
                                style={{ backgroundColor: 'rgb(82, 196, 26)' }}
                            >
                                Download Report
                            </Button>
                        </a>
                    </React.Fragment>
                )
            }

            function renderLayoutSelector() {

                if (report_type !== 'MANIFEST' || desig) return null;

                return <>
                    <Form.Item label="Choose a layout for your manifest spreadsheet">
                        {getFieldDecorator('printoutLayout', {
                            rules: [{ required: true, message: 'You must select a layout' }],
                            valuePropName: 'selectedClassName',
                        })(
                            <ManifestPrintoutLayoutSelect
                                manifestType="MultiFlightManifest"
                                selectFirstByDefault
                                noLayoutsFoundText={'Download an individual flight manifest by clicking the "Download" button at the end of the flight record in the "Details" tab.'}
                            />
                        )}
                    </Form.Item>
                </>
            }

            return (
                <Form>
                    {error ? (
                        <Alert type="error" showIcon message="Failed to export report" />
                    ) : null}
                    {renderFileType()}
                    {renderTitleRowText()}
                    {renderColumnSets()}
                    {renderLayoutSelector()}
                    <Form.Item>
                        {renderExportButton()}
                        {renderDownloadButton()}
                    </Form.Item>
                </Form>
            )
        }}
        </Mutation>
    )
}

ReportExporter.propTypes = {
    report_id: PropTypes.string.isRequired,
    column_sets: PropTypes.arrayOf(
        PropTypes.shape({
            setName: PropTypes.string.isRequired,
            key: PropTypes.string.isRequired,
            columns: PropTypes.arrayOf(
                PropTypes.shape({
                    label: PropTypes.string.isRequired,
                    key: PropTypes.string.isRequired
                })
                ).isRequired,
                dataSource: PropTypes.shape({
                    set: PropTypes.string.isRequired,
                    key: PropTypes.string.isRequired
                }),
        })
    )
}

ReportExporter = Form.create()(ReportExporter)

ReportExporter.displayName = 'Form(ReportExporter)'

const DataExporter = ({ ...props }) => <ReportExporter {...props} />

export { ReportExporter, DataExporter };
